import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10571 18.8943C3.27723 17.0658 2.25 14.5859 2.25 12C2.25 9.41414 3.27723 6.93419 5.10571 5.10571C6.93419 3.27723 9.41414 2.25 12 2.25C13.2804 2.25 14.5482 2.50219 15.7312 2.99217C16.9141 3.48216 17.9889 4.20034 18.8943 5.10571C19.7997 6.01108 20.5178 7.08591 21.0078 8.26884C21.4978 9.45176 21.75 10.7196 21.75 12C21.75 13.2804 21.4978 14.5482 21.0078 15.7312C20.5178 16.9141 19.7997 17.9889 18.8943 18.8943C17.9889 19.7997 16.9141 20.5178 15.7312 21.0078C14.5482 21.4978 13.2804 21.75 12 21.75C9.41414 21.75 6.93419 20.7228 5.10571 18.8943ZM8.46967 12.3659C8.17678 12.6588 8.17678 13.1337 8.46967 13.4266C8.76256 13.7195 9.23744 13.7195 9.53033 13.4266L12 10.9569L14.4697 13.4266C14.7626 13.7195 15.2374 13.7195 15.5303 13.4266C15.8232 13.1337 15.8232 12.6588 15.5303 12.3659L12.5303 9.36591C12.2374 9.07302 11.7626 9.07302 11.4697 9.36591L8.46967 12.3659Z"
        fill={colorValue}
      />
    </svg>
  );
};
